import React from 'react'
import styled from 'particles/themes/styled'
import Tooltip, { TooltipPlacement } from 'particles/Tooltip'
import Icon, { IconColor, IconSize } from 'particles/Icon'

interface InfoTooltipProps {
    title?: string
    label: React.ReactNode
    iconColor?: IconColor
    size?: IconSize
    marginLeft?: string
    tooltipPlacement?: TooltipPlacement
}
const Container = styled.div<{ size: string; marginLeft: string }>`
    cursor: pointer;
    max-width: ${({ size }) => (size ? size : 'fit-content')};
    max-height: ${({ size }) => (size ? size : 'fit-content')};
    display: flex;
    align-items: center;
    margin-left: ${({ marginLeft }) => marginLeft};
`

const InfoTooltip: React.FC<InfoTooltipProps> = ({
    title,
    label,
    tooltipPlacement,
    iconColor = 'actionInverse',
    size = '16px',
    marginLeft = '10px',
}) => {
    return (
        <Tooltip title={title} label={label} placement={tooltipPlacement}>
            <Container size={size} className="info-tooltip" marginLeft={marginLeft}>
                <Icon name="info" color={iconColor} size={size} />
            </Container>
        </Tooltip>
    )
}

export default React.memo(InfoTooltip)
